import { ConfigProvider, Layout, Row, Space, theme } from 'antd';
import PrivacyPolicyContent from '../src/components/PrivacyPolicyContent';
import { getCurrentYear } from '../src/utils/helpers';

const { Footer, Content } = Layout;

export default function PrivacyPolicy() {
    const {
        token: { colorWhite }
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorBgLayout: colorWhite
                }
            }}
        >
            <Layout style={{ height: '100vh' }}>
                <Content style={{ overflow: 'hidden', overflowY: 'scroll', padding: '2rem' }}>
                    <Row align="middle" justify="center" style={{ marginTop: '1rem' }}>
                        <PrivacyPolicyContent isOnModal={false} />
                    </Row>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    <Space>© Grispi, {getCurrentYear()}</Space>
                </Footer>
            </Layout>
        </ConfigProvider>
    );
}
